import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "barcode-container" }
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 0,
  class: "barcode-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("canvas", {
      class: "barcode-renderer",
      id: _ctx.barcodeInstanceId
    }, "...", 8, _hoisted_2),
    (_ctx.overlay)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "barcode-btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDownloadClick && _ctx.onDownloadClick(...args)))
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("svg", {
              class: "svg-icon",
              viewBox: "0 0 32 32",
              xmlns: "http://www.w3.org/2000/svg",
              fill: "#0b4dff"
            }, [
              _createElementVNode("g", null, [
                _createElementVNode("path", { d: "M26,21v6.8c0,0.1,0,0.2-0.1,0.2H6.1C6,28,6,27.9,6,27.8V21H4v6.8C4,29,4.9,30,6.1,30h19.8c1.2,0,2.1-1,2.1-2.2V21H26z" }),
                _createElementVNode("polygon", { points: "22.9,16.9 21.5,15.5 17,20 17,2 15,2 15,20 10.5,15.5 9.1,16.9 16,23.8" })
              ])
            ], -1)
          ])),
          _createElementVNode("button", {
            class: "barcode-btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPrintClick && _ctx.onPrintClick(...args)))
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("svg", {
              class: "svg-icon",
              viewBox: "0 0 32 32",
              xmlns: "http://www.w3.org/2000/svg",
              fill: "#0b4dff"
            }, [
              _createElementVNode("path", { d: "M30,13.4c0-1.3-1-2.4-2.3-2.4H25V2H7v9H4.3C3,11,2,12.1,2,13.4V26h5v4h18v-4h5V13.4z M9,4h14v7H9V4z M23,28H9v-6h14V28zM28,24h-3v-4H7v4H4V13.4C4,13.2,4.1,13,4.3,13H7h18h2.7c0.2,0,0.3,0.2,0.3,0.4V24z" })
            ], -1)
          ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}